import { renderTextCloudMarkerBackground } from 'app/image/rasterize/markers/text/cloud';
import { getTextFillPainter, getTextStrokePainter, renderText, } from 'app/image/rasterize/markers/text/text';
import { fillTextMarkerRenderer } from '../painters';
export const renderTextMarker = (marker, fonts, ctx, opts) => {
    var _a;
    const type = (_a = marker.background) === null || _a === void 0 ? void 0 : _a.type;
    switch (type) {
        case 'cloud':
            renderTextCloudMarkerBackground(marker, fonts, ctx);
            break;
        default:
            {
                const fillPainter = getTextFillPainter(marker);
                const strokePainter = getTextStrokePainter(marker);
                renderText(marker, fonts, ctx, style => {
                    fillTextMarkerRenderer(ctx, style, strokePainter, fillPainter, opts);
                });
            }
            break;
    }
};
